import axios from "./axios";

export async function listarServicosPublicos() {
  const response = await axios.get("/portal/servicos");
  return response.data;
}

export async function buscarServicoPublico(slug) {
  const response = await axios.get(`/portal/servicos/${slug}`);
  return response.data;
}

export async function buscarHomeConfigPublico() {
  const response = await axios.get("/portal/home");
  return response.data;
}

export async function buscarHomeConfigAdmin() {
  const response = await axios.get("/portal/admin/home");
  return response.data;
}

export async function atualizarHomeConfigAdmin(payload) {
  const response = await axios.put("/portal/admin/home", payload);
  return response.data;
}

export async function listarServicosAdmin() {
  const response = await axios.get("/portal/admin/servicos");
  return response.data;
}

export async function buscarServicoAdmin(id) {
  const response = await axios.get(`/portal/admin/servicos/${id}`);
  return response.data;
}

export async function criarServicoAdmin(payload) {
  const response = await axios.post("/portal/admin/servicos", payload);
  return response.data;
}

export async function atualizarServicoAdmin(id, payload) {
  const response = await axios.put(`/portal/admin/servicos/${id}`, payload);
  return response.data;
}

export async function publicarServicoAdmin(id) {
  const response = await axios.post(`/portal/admin/servicos/${id}/publicar`);
  return response.data;
}

export async function arquivarServicoAdmin(id) {
  const response = await axios.post(`/portal/admin/servicos/${id}/arquivar`);
  return response.data;
}

export async function despublicarServicoAdmin(id) {
  const response = await axios.post(`/portal/admin/servicos/${id}/despublicar`);
  return response.data;
}

export async function buscarContextoAdmin() {
  const response = await axios.get("/portal/admin/contexto");
  return response.data;
}

export async function listarRevisoesServicoAdmin(id) {
  const response = await axios.get(`/portal/admin/servicos/${id}/revisoes`);
  return response.data;
}

export async function listarAuditoriaServicoAdmin(id) {
  const response = await axios.get(`/portal/admin/servicos/${id}/auditoria`);
  return response.data;
}

export async function restaurarRevisaoServicoAdmin(id, revisaoId) {
  const response = await axios.post(`/portal/admin/servicos/${id}/revisoes/${revisaoId}/restaurar`);
  return response.data;
}
